const useFormatStatus = (
	status:
		| 'ACCEPTED'
		| 'ACTIVE'
		| 'CANCELLED'
		| 'CLOSED'
		| 'COMPLETE'
		| 'CONFIRMED'
		| 'CREATED'
		| 'EXPIRED'
		| 'FAILED'
		| 'GENERATED'
		| 'IN_PROGRESS'
		| 'INITIALIZED'
		| 'MISSING_DATA'
		| 'NOPAYOUT'
		| 'PAID'
		| 'PARTIALLY_FAILED'
		| 'PARTIALLY_REFUNDED'
		| 'PASSED'
		| 'PENDING'
		| 'PENDING_CANCELLED'
		| 'PENDING_REFUND'
		| 'PROCESSED'
		| 'READY'
		| 'RECONCILED'
		| 'REFUNDED'
		| 'RETURNED'
		| 'REJECTED'
		| 'SCHEDULED'
		| 'SUSPENDED'
		| 'WAITING'
		| 'WAITING_DATA'
		| 'EXTERNAL REVIEW'
		| 'REVIEW'
		| string // TODO add status type and remove this
) => {
	switch (status?.toUpperCase()) {
		case 'ACCEPTED':
		case 'ACTIVE':
		case 'COMPLETE':
		case 'CONFIRMED':
		case 'GENERATED':
		case 'PAID':
		case 'PASSED':
		case 'PROCESSED':
		case 'RECONCILED':
			return 'success';
		case 'CREATED':
		case 'IN_PROGRESS':
		case 'APPROVED':
		case 'NOPAYOUT':
		case 'PENDING':
		case 'PENDING_REFUND':
		case 'REGENERATED':
		case 'SCHEDULED':
		case 'WAITING':
		case 'WAITING_DATA':
		case 'EXTERNAL REVIEW':
			return 'pending';
		case 'MISSING_DATA':
		case 'PARTIALLY_REFUNDED':
		case 'READY':
		case 'RETURNED':
		case 'REVIEW':
			return 'warning';
		case 'CANCELLED':
		case 'FAILED':
		case 'PARTIALLY_FAILED':
		case 'PENDING_CANCELLED':
		case 'REJECTED':
			return 'error';
		case 'EXPIRED':
		case 'INITIALIZED':
		case 'REFUNDED':
		default:
			return 'default';
	}
};

export default useFormatStatus;
